import {
  type ComponentProps,
  type LayoutData,
  Region,
} from "@enonic/react-components";

export const ArticleBodyLayout = ({
  component,
  meta,
}: ComponentProps<LayoutData>) => {
  return (
    <div className="narrow-container">
      <Region
        data={component.regions.middle.components}
        meta={meta}
        name="middle"
      />
    </div>
  );
};
